import { AddressDetailsDto } from '@eneco/dc-be/client';

const IsAddressInWalloniaOrBrussels = (address: AddressDetailsDto | undefined) => {
  if (!address) return false;
  return IsPostalCodeInWalloniaOrBrussels(address.postalCode);
};

const IsPostalCodeInWalloniaOrBrussels = (postalCode: string | undefined) => {
  if (!postalCode) return false;
  const code = Number(postalCode);
  if (code >= 1000 && code <= 1299) return true;
  if ((code >= 1300 && code <= 1499) || (code >= 4000 && code <= 7999)) return true;
};

export { IsAddressInWalloniaOrBrussels, IsPostalCodeInWalloniaOrBrussels };
